import { Button, Col, Divider, Form, Input, InputNumber, Row } from "antd";
import React from "react";

const DetailInformation = () => {
  return (
    <React.Fragment>
      <Row gutter={[16, 16]}>
        <Col span={24}>ข้อมูล Visit</Col>
        <Col span={8}>
          <Form.Item
            label="ID Visit"
            name="visitNo"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลlocation!" }]}
          >
            <Input className="color-primary" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Location"
            name="location"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลlocation!" }]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label=" ">
            <Button type="ghost">Map</Button>
          </Form.Item>
        </Col>
        <Divider className="m-0" />
        <Col span={24}>ข้อมูล Vital sign</Col>
        <Col span={8}>
          <Form.Item
            label="น้ำหนัก (กก.)"
            name="weight"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลน้ำหนัก!" }]}
          >
            {/* <Input placeholder="นำ้หนัก" /> */}
            <InputNumber<number>
              min={0}
              max={200}
              step={0.01}
              disabled
              placeholder="น้ำหนัก (กก.)"
              className="w-100"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="ส่วนสูง (ซม.)"
            name="height"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลส่วนสูง!" }]}
          >
            <InputNumber<number>
              min={0}
              max={200}
              step={0.01}
              disabled
              placeholder="ส่วนสูง (กก.)"
              className="w-100"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="BMI (Auto)"
            name="bmi"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูล BMI!" }]}
          >
            <InputNumber<number>
              min={0}
              max={200}
              step={0.01}
              disabled
              placeholder="BMI (Auto)"
              className="w-100"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="ความดัน (mm/Hg)"
            name="pressure"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลความดัน!" }]}
          >
            <Input placeholder="ความดัน (mm/Hg)" disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="อุณหภูมิ (c)"
            name="temperature"
            rules={[{ required: false, message: "กรุณาใส่ข้อมูลอุณหภูมิ!" }]}
          >
            <InputNumber<number>
              min={0}
              max={500}
              step={0.01}
              disabled
              placeholder="อุณหภูมิ (c)"
              className="w-100"
            />
          </Form.Item>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default DetailInformation;
